<script setup lang="ts">
import PricesUnlimItem from "~/components/sx/prices/PricesUnlimItem.vue";
import { UiButton } from '@common/ui-kit';
import {type IPromiseTariff, useCustomTariffStore} from "~/stores/useCustomTariffStore";

const { t } = useI18n();
const { tariffs: storeTariffs } = useCustomTariffStore();

const hiddenTariffsVisible = ref(false);

const tariffs = computed(() => {
  return storeTariffs.value.unlim.slice(0, 2);
});

const tariffsHidden = computed(() => {
  return storeTariffs.value.unlim.slice(2);
})

const visibleTariffs = computed(() => {
  return hiddenTariffsVisible.value
    ? tariffs.value.concat(tariffsHidden.value)
    : tariffs.value;
});

const getTrafficPriceItemTag = (index: number) => {
  if (index === 0) {
    return t('pages.home.prices.common.initialTariff')
  } else if (index === 1) {
    return t('pages.home.prices.common.mostProfitable')
  }
};
</script>

<template>
  <div class="prices-unlim unlim">
    <div class="prices-unlim__content">
      <TransitionGroup
        v-if="visibleTariffs.length"
        name="fade-list"
        tag="div"
        class="prices-unlim__content"
      >
        <PricesUnlimItem
          v-for="(item, index) in visibleTariffs"
          :key="index"
          :item="item"
          :tag="getTrafficPriceItemTag(index)"
        />
      </TransitionGroup>
    </div>

    <div class="prices-unlim__controls">
      <UiButton
        class="prices-unlim__btn "
        @click="hiddenTariffsVisible = !hiddenTariffsVisible"
      >
        <span class="default-tag">
          {{ hiddenTariffsVisible ? $t('pages.home.prices.common.hide') : `${$t('pages.home.prices.common.showAllTariffs')} (${tariffsHidden.length})`  }}
        </span>
      </UiButton>
    </div>
  </div>
</template>

<style scoped lang="scss">
.prices-unlim {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1200px;
  width: 100%;
  transition: .3s;
  &__content {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  &__controls {
    display: flex;
    justify-content: center;
  }
  &__btn {
    background: #fff;
    color: #000;
    height: 44px;
    border-radius: 52px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0;
    &:hover {
      background: #eeeeee !important;
    }
  }
}

.fade-list-enter-active,
.fade-list-leave-active {
  transition: all 0.4s ease;
}

.fade-list-enter-from,
.fade-list-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

@media (max-width: 1199px) {
  .prices-unlim {
    &__content {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
}
</style>
